export const DEFAULT_FIXED_IMAGE_PROMPT = '参考图片来生成图片';

export const DEFAULT_CHAR_STATE_PROMPT_PREFIX =
  '参考图1 的人物，根据下面描述生成，规则：单图包含头部单独正面视图+全身三视图(正面/侧面/背面),从左到右排列,纯白色背景,布局清晰无重叠、比例协调,视图间预留均匀空白;描述：';

export function parseRefImages(value?: string): string[] {
  try {
    return JSON.parse(value || '[]') as string[];
  } catch {
    return [];
  }
}

/** 每个资产的参考图总预算（项目参考图 + 用户上传参考图）。 */
export const MAX_TOTAL_REF_IMAGES = 5;
